<div class="container">
    <div class="progress-stacked row">
            <div class="col-3">
                <div class="bar-name bar-text">{{barTitle || '---'}}</div>
            </div>
            <div class="col-9">
                <div class="row w-100">

                    <div class="col-6 flex-grow-1 p-0 d-flex justify-content-end flex-row-reverse">
                        <div *ngFor="let value of other; let i = index" class="progress"
                             role="progressbar"
                             [attr.aria-valuenow]="value"
                             [attr.aria-valuemin]="0" aria-valuemax="100"
                             [ngStyle]="{'flex': value}">

                            <div class="progress-bar" [ngClass]="'level_'+i">
                                <span class="segment-value ">{{value.toFixed(1)}}%</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 flex-grow-1 p-0 d-flex ">
                        <div *ngFor="let value of success; let i = index" class="progress"
                             role="progressbar"
                             [attr.aria-valuenow]="value"
                             [attr.aria-valuemin]="0" aria-valuemax="100"
                             [ngStyle]="{'flex': value}">

                            <div class="progress-bar" [ngClass]="'s_level_'+i">
                                <span class="segment-value ">{{value.toFixed(1)}}%</span>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        <!--        <div *ngFor="let value of values; let i = index" class="progress"-->
        <!--             role="progressbar"-->
        <!--             [attr.aria-valuenow]="value"-->
        <!--             [attr.aria-valuemin]="0" aria-valuemax="100"-->
        <!--             [ngStyle]="{'flex': value}">-->

        <!--            <div class="progress-bar" [ngClass]="'level_'+i">-->
        <!--                <span class="segment-value ">{{value.toFixed(1)}}%</span>-->
        <!--            </div>-->
        <!--        </div>-->
    </div>
</div>
